import { z } from 'zod'

import { imageSchema } from './image'
import { listQueryZodFields } from './system'
import { dbEntitySchema } from './system'

export const venueLayoutSectionSchema = dbEntitySchema.extend({
  venue: z.string(),
  venueLayout: z.string(),
  name: z.string(),
  polygon: z
    .array(
      z.object({
        xPos: z.number(),
        yPos: z.number(),
      })
    )
    .optional()
    .nullable(),
  images: z.array(imageSchema),
  totalTables: z.number().optional(),
})

export const venueLayoutSectionListQuerySchema = z.object({
  ...listQueryZodFields,
  venueId: z.string().or(z.array(z.string())).optional().nullable(),
  venueLayoutId: z.string().or(z.array(z.string())).optional().nullable(),
})

export const venueLayoutSectionsByLayoutListQuerySchema = z.object({
  ...listQueryZodFields,
})

export const venueLayoutSectionListResponseSchema = z.object({
  data: z.array(venueLayoutSectionSchema),
})

export const venueLayoutSectionCreateArgsSchema = z.object({
  venueId: z.string(),
  venueLayoutId: z.string(),
  name: z.string(),
  polygon: z
    .array(
      z.object({
        xPos: z.number(),
        yPos: z.number(),
      })
    )
    .optional()
    .nullable(),
  images: z.array(imageSchema).optional(),
})

export const venueLayoutSectionUpdateByIdArgsSchema = z
  .object({
    name: z.string(),
    polygon: z
      .array(
        z.object({
          xPos: z.number(),
          yPos: z.number(),
        })
      )
      .nullable(),
    images: z.array(imageSchema),
  })
  .partial()
